import { ScenarioStatus } from '../types';

export const getScenarioStatus = (status: string): ScenarioStatus => {
  switch (status) {
    case 'DRAFT':
      return ScenarioStatus.Draft;
    case 'ACTIVE':
      return ScenarioStatus.Active;
    case 'IN_PROGRESS':
      return ScenarioStatus.InProgress;
    case 'DONE':
      return ScenarioStatus.Done;
    case 'CANCELLED':
      return ScenarioStatus.Canceled;
    default: {
      throw new Error('Invalid scenario status');
    }
  }
};
